import React, { lazy, Suspense } from 'react';

const LazyLeadDetail = lazy(() => import('./LeadDetail'));

const LeadDetail = (props: React.JSX.IntrinsicAttributes & { children?: React.ReactNode; }) => (
  <Suspense fallback={null}>
    <LazyLeadDetail {...props} />
  </Suspense>
);

export default LeadDetail;
